import React from 'react'
import { clsx } from 'clsx'
import Infographic from '@/components/InfoGraphic/InfoGraphic'
import { WidgetInfographicProps } from '@/types/cms'
import styles from './InfoGraphicDefault.module.scss'

const InfoGraphicDefault = ({ item }: { item: WidgetInfographicProps }) => {
  return (
    <>
      {item.items && item.items.length > 0 && (
        <div
          className={clsx(
            styles.wrapper,
            styles[item.model.fields.view],
            !item.model.fields.noBorder && styles['border'],
          )}
        >
          {item.items?.map((infographic) => (
            <Infographic key={infographic.id} infographic={infographic} />
          ))}
          {item.model.fields.link?.url && item.model.fields.linkTxt && (
            <div className={styles.linkwrapper}>
              <a
                href={item.model.fields.link.url}
                title={item.model.fields.linkTxt}
                target={item.model.fields.link.target}
              >
                {item.model.fields.linkTxt}
              </a>
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default InfoGraphicDefault
